import { NavigationLinkStyled } from './scroll-link.style';

export const NavigationLink = NavigationLinkStyled;
